module.exports = __webpack_public_path__ + "img/modelshow07.215a2b11.png";